import * as moment from "moment";
import { filter, map, tap } from "rxjs/operators";
import { isNumber } from "util";
import { Dropdown } from "primeng/dropdown/dropdown";
import { MultiSelect } from "primeng/multiselect/public_api";
import { Checkbox } from "primeng/checkbox/checkbox";
import { TriStateCheckbox } from "primeng/tristatecheckbox/public_api";
import { Calendar } from "primeng/calendar/calendar";
import { AutoComplete } from "primeng/autocomplete/public_api";
import { InputSwitch } from "primeng/inputswitch/public_api";
import { Slider } from "primeng/slider/slider";
import { SelectButton } from "primeng/selectbutton/public_api";
import { RadioButton } from "primeng/radiobutton/public_api";
import { Chips } from "primeng/chips/chips";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { pipe } from "rxjs";
import { AuthenticationService } from "src/app/core/login/authentication/authentication.service";
import { DistanceModel } from "../models/geo/distance.model";
import { TypeDataPlannerMatrix } from "../models/geo/typeDataPlannerMatrix.model";
import { EstimacionParadaModel } from "../models/regulares/estimacionParada.model";

export function ResetFiltersAuto(childs: any[]) {
    childs.map((child) => {
        switch (child.constructor.name) {
            case "Dropdown":
                ResetDrop(child);
                break;
            case "MultiSelect":
                ResetMultiSelects(child);
                break;
            case "Checkbox":
                ResetCheckbox(child);
                break;
            case "TriStateCheckbox":
                ResetTriCheckbox(child);
                break;
            case "Calendar":
                ResetCalendar(child);
                break;
            case "AutoComplete":
                ResetAutocomplete(child);
                break;
            case "InputSwitch":
                ResetInputSwitch(child);
                break;
            case "Slider":
                ResetSlider(child);
                break;
            case "SelectButton":
                ResetSelectButton(child);
                break;
            case "RadioButton":
                ResetRadioButton(child);
                break;
            case "Chips":
                ResetChip(child);
                break;
            case "HTMLInputElement":
                ResetInput(child);
                break;
            default:
                break;
        }
    });
}

export function ResetInputs(inputs: HTMLInputElement[]) {
    inputs.map((input) => {
        ResetInput(input);
    });
}

export function ResetInput(input: HTMLInputElement) {
    input.value = null;
}

export function ResetDrops(drops: Dropdown[]) {
    drops.map((drop) => {
        ResetDrop(drop);
    });
}

export function ResetDrop(drop: Dropdown) {
    drop.value = null;
    drop.selectedOption = null;
}

export function ResetMultiSelects(multiselects: MultiSelect[]) {
    multiselects.map((multiselect) => {
        ResetMultiSelect(multiselect);
    });
}

export function ResetMultiSelect(multiselect: MultiSelect) {
    multiselect.value = [];
}

export function ResetCheckboxs(checks: Checkbox[]) {
    checks.map((check) => {
        ResetCheckbox(check);
    });
}

export function ResetCheckbox(check: Checkbox) {
    check.value = false;
}

export function ResetTriCheckboxs(trichecks: TriStateCheckbox[]) {
    trichecks.map((tricheck) => {
        ResetTriCheckbox(tricheck);
    });
}

export function ResetTriCheckbox(tricheck: TriStateCheckbox) {
    tricheck.value = null;
}

export function ResetCalendars(calendars: Calendar[]) {
    calendars.map((calendar) => {
        ResetCalendar(calendar);
    });
}

export function ResetCalendar(calendar: Calendar) {
    calendar.value = null;
}

export function ResetAutocompletes(autocompletes: AutoComplete[]) {
    autocompletes.map((autocomplete) => {
        ResetAutocomplete(autocomplete);
    });
}

export function ResetAutocomplete(autocomplete: AutoComplete) {
    autocomplete.value = null;
}

export function ResetInputSwitchs(inputswitchs: InputSwitch[]) {
    inputswitchs.map((inputswitch) => {
        ResetInputSwitch(inputswitch);
    });
}

export function ResetInputSwitch(inputswitch: InputSwitch) {
    inputswitch.writeValue(false);
}

export function ResetSliders(sliders: Slider[]) {
    sliders.map((slider) => {
        ResetSlider(slider);
    });
}

export function ResetSlider(slider: Slider) {
    if (slider.range) {
        slider.writeValue([]);
    } else {
        slider.writeValue(slider.min == 0 ? 0 : slider.min);
    }
}

export function ResetSelectButtons(selectbuttons: SelectButton[]) {
    selectbuttons.map((selectbutton) => {
        ResetSelectButton(selectbutton);
    });
}

export function ResetSelectButton(selectbutton: SelectButton) {
    selectbutton.multiple
        ? (selectbutton.value = [])
        : (selectbutton.value = null);
}

export function ResetRadioButtons(radiobuttons: RadioButton[]) {
    radiobuttons.map((radiobutton) => {
        ResetRadioButton(radiobutton);
    });
}

export function ResetRadioButton(radiobutton: RadioButton) {
    radiobutton.value = null;
}

export function ResetChips(chips: Chips[]) {
    chips.map((chip) => {
        ResetChip(chip);
    });
}

export function ResetChip(chip: Chips) {
    chip.value = [];
}

export function GetTimeOfTimeSpan(time: string) {
    return time ? time.substring(0, 5) : null;
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function TransformDate(target, key, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function () {
        return originalMethod
            .apply(this)
            .pipe(map((obj) => Object.assign({}, obj, stringToDate(obj))));
    };
    return descriptor;
}

export function LoopAllObject(obj) {
    Object.keys(obj).map((key) => {
        if (isDate(obj[key])) {
            obj[key] = moment(obj[key]).toDate();
        }
        if (Array.isArray(obj[key])) {
            obj[key].map((child) => LoopAllObject(child));
        }
    });
}

export function isDate(s) {
    if (isNumber(s)) {
        return false;
    }
    return moment(s, moment.ISO_8601, true).isValid();
}

export function stringToDate(obj) {
    return Object.keys(obj)
        .filter((key) => obj[key] && isDate(obj[key]))
        .map((key) => (obj[key] = moment(obj[key]).toDate()));
}

export function ifAddDateToObject(objectTo: any, date, name?) {
    if (date instanceof Date) {
        Object.defineProperty(objectTo, name, {
            value: moment(date).format("DD/MM/YYYY"),
            enumerable: true,
        });
    }
}

export function markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control: any) => {
        control.markAsTouched();
        control.markAsDirty();
        if (control.controls) {
            control.controls.forEach((c) => this.markFormGroupTouched(c));
        }
    });
}

export function toFormData<T>(formValue: T) {
    const formData = new FormData();

    for (const key of Object.keys(formValue)) {
        const value = formValue[key];
        formData.append(key, value);
    }

    return formData;
}

export function toResponseBody<T>() {
    return pipe(
        filter((event: HttpEvent<T>) => {
            return event.type === HttpEventType.Response;
        }),
        map((res: HttpResponse<T>) => res.body)
    );
}

export function uploadProgress<T>(cb: (progress: number) => void) {
    return tap((event: HttpEvent<T>) => {
        if (event.type === HttpEventType.UploadProgress) {
            cb(Math.round((100 * event.loaded) / event.total));
        }
    });
}
export function responseProgress<T>(cb: (progress: number) => void) {
    return tap((event: HttpEvent<T>) => {
        if (event.type === HttpEventType.DownloadProgress) {
            cb(Math.round((100 * event.loaded) / event.total));
        }
    });
}

export function requiredFileType(type: string) {
    return function (control: FormControl) {
        const file = control.value;
        if (file) {
            const extension = file.name.split(".")[1].toLowerCase();
            if (type.toLowerCase() !== extension.toLowerCase()) {
                return {
                    requiredFileType: "Archivo PDF requerido.",
                };
            }
        }

        return null;
    };
}

export function maxSize(maxMb: number) {
    return function (control: FormControl) {
        const file = control.value;
        if (file) {
            if (maxMb * 1024 * 1024 < file.size) {
                return {
                    maxExceeded: "Tamaño máximo excedido. " + maxMb + "MB",
                };
            }
            return null;
        }
        return null;
    };
}

export function urlEmbeddedCheck() {
    return function (control: FormControl) {
        if (control.value?.valor) {
            var errorMessage = {
                embeddedNotWork:
                    "La url introducida no devuelve un video/audio reproducíble.",
            };
            var video = document.createElement("video");
            video.setAttribute("src", control.value.valor);
            return video.isConnected ? null : errorMessage;
        }
        return null;
    };
}

export function getOptionsCalendar() {
    return {
        initialView: "dayGridMonth",
        initialDate: new Date(),
        headerToolbar: {
            left: "prev,next",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        locale: "es",
        buttonText: {
            today: "Hoy",
            month: "Mes",
            week: "Semana",
            day: "Día",
            list: "Lista",
        },
        firstDay: 1,
        aspectRatio: 1.7,
        nowIndicator: true,
    };
}


export function formatDateIso(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatUrlNoAuth(url: string, endpoint: string): string {
    return `${url}/${endpoint}`;
}

export function formatUrl(
    auth: AuthenticationService,
    url: string,
    endpoint: string
): string {
    //return `${auth.urlBase}${url}/${endpoint}`;
    return `${auth.urlTrafico}${url}/${endpoint}`;
}
export function formatUrlTrafico(
    auth: AuthenticationService,
    url: string,
    endpoint: string
): string {
    return `${auth.urlTrafico}${url}/${endpoint}`;
}
export function formatUrlRegulares(
    href: string,
    url: string,
    endpoint: string
): string {
    return `${href}${url}/${endpoint}`;
}
export function convertDateAndTimeToDate(hora, dia) {
    var time = moment(hora).toDate();
    var date = moment(dia).toDate();
    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        time.getHours(),
        time.getMinutes(),
        0
    );
}

export function convertDateToLocal(dia) {
    var date = moment(dia).toDate();
    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        0
    );
}

export function extractDate(date: Date) {
    var now_utc = Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0
    );
    return new Date(now_utc);
}

export function extractTime(date: Date) {
    return new Date(
        1,
        1,
        1,
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    );
}

export function formTaxis(
    fb: FormBuilder,
    auth: AuthenticationService,
    create: boolean
) {
    // esto va a diferenciar entre crear y updatear un servicio ya creado. Al crear no son obligatorios unos campos pero para cerrar una servicio si
    var validatorsRequired = create ? [] : [Validators.required];
    return fb.group({
        id_servicio: [null],
        fechaser: [new Date()],
        codigbus: [null],
        matricula: [null],
        tipo_bus: [null],
        horapedser: [new Date()],
        horainiser: [new Date(), Validators.required],
        horafinser: [null, Validators.required],
        KmIni: [null, Validators.required],
        KmFin: [null, validatorsRequired],
        kmvacio: [0],
        id_ruta: [null],
        id_usuario: [null],
        observac: [null, Validators.maxLength(512)],
        Itinerario: [null, Validators.maxLength(512)],
        vehiculos: [
            auth.currentUserValue.loginTaxis.vehiculo,
            Validators.required,
        ],
        taxis_usuarios: [null, validatorsRequired],
        taxis_serv_cab: [null, Validators.required],
        taxis_rutas: [null, validatorsRequired],
        cod_vtc: [null],
        reduc_emisiones: [0],
        mujer: [0],
        min_espera: [0, [Validators.required, Validators.min(0)]],
        numservicio: [null],
        tiposbus: [null],
        origen: [null, [Validators.maxLength(512)]],
        destino: [null, [Validators.maxLength(512)]],
        latori: [null],
        lngori: [null],
        latdest: [null],
        lngdest: [null],
        firma: [[]],
        duracion: [0],
        kilometros: [0],
    });
}

export function buildDistanceObj(res): DistanceModel {
    return new DistanceModel(
        res[TypeDataPlannerMatrix.DISTANCE],
        res[TypeDataPlannerMatrix.DURATION]
    );
}

export function validateNewServTaxi(form: FormGroup) {
    let message: string = "";
    message = validateRuta(form, message);
    return message != "" ? message : null;
}

export function validateCierreServTaxi(form: FormGroup): string {
    let message: string = "";
    message = validateDiffKm(form, message);
    message = validateRuta(form, message);
    return message !== "" ? message : null;
}

export function validateDiffKm(form: FormGroup, message: string): string {
    if (form.get("KmIni").value > form.get("KmFin").value) {
        message +=
            "Los kilómetros iniciales no pueden ser mayores que los finales.";
    }

    if (form.get("KmIni").value == form.get("KmFin").value) {
        message += "Los kilómetros iniciales y finales son iguales.";
    }
    if (
        buildKmTaxis(form.get("KmIni").value, form.get("KmFin").value) >= 9999
    ) {
        message += "El servicio tiene más de 10000 km de diferencia.";
    }

    return message;
}

export function validateRuta(form: FormGroup, message: string): string {
    if (
        !(
            (form.get("origen").value && form.get("destino").value) ||
            form.get("Itinerario").value
        )
    ) {
        message += "Debes rellenar origen y destino, o el itinerario.";
    }
    return message;
}

export function buildDataSendFormTaxis(form: FormGroup) {
    var obj = form.value;
    if (obj["horainiser"] && obj["horafinser"]) {
        obj["duracion"] = buildDurationTaxis(
            obj["horainiser"],
            obj["horafinser"]
        );
    }
    if (notNullOrUndefined(obj["KmIni"]) && notNullOrUndefined(obj["KmFin"])) {
        obj["kilometros"] = buildKmTaxis(obj["KmIni"], obj["KmFin"]);
    }
    obj["horainiser"] = moment(obj["horainiser"] as Date).format("HH:mm:ss");
    obj["horafinser"] = moment(obj["horafinser"] as Date).format("HH:mm:ss");
    return obj;
}

export function notNullOrUndefined(obj) {
    return obj != null && obj != undefined;
}

export function buildDurationTaxis(ini: Date, fin: Date): number {
    return moment.duration(moment(fin).diff(moment(ini))).asMinutes();
}

export function buildKmTaxis(ini: number, fin: number) {
    return fin - ini;
}

export function stringToByteArray(str: string) {
    var binaryString = atob(str.split(",")[1]);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return Array.from(bytes);
}

export function changeLowerCase(json: any): any {
    const resultado = {};
    for (const key in json) {
        if (json.hasOwnProperty(key)) {
            const keyEnMinuscula = key.charAt(0).toLowerCase() + key.slice(1);
            resultado[keyEnMinuscula] = json[key];
        }
    }
    return resultado;
}

export function isLocalhost() {
    return (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
    );
}

export function searchItemMenor(array: any[], propiedad?: string) {
    if (propiedad) {
        return array.findIndex(
            (item, indice) =>
                indice > 0 && item[propiedad] < array[indice - 1][propiedad]
        );
    }
    return array.findIndex(
        (item, indice) => indice > 0 && item < array[indice - 1]
    );
}

export function convertirTimeSpanADate(item: EstimacionParadaModel): Date {
    const [horas, minutos, segundos] = (item.hora_paso as unknown as string)
        .split(":")
        .map(Number);
    const fechaActual = new Date();
    const horaDate = new Date(
        fechaActual.getFullYear(),
        fechaActual.getMonth(),
        fechaActual.getDate(),
        horas,
        minutos,
        segundos
    );
    return horaDate;
}

export function obtenerIndiceDelMedio(arr: any[]): number {
    const longitud = arr.length;
    if (longitud === 0) {
        return -1;
    }
    const indiceDelMedio = Math.floor(longitud / 2);
    return indiceDelMedio;
}

export function utf8_to_b64(str) {
    let plainTextBytes = new TextEncoder().encode(str);
    return btoa(String.fromCharCode(...plainTextBytes));
}

export function base64Decode(encodedText: string): string {
    let decodedBytes = atob(encodedText)
        .split("")
        .map((c) => c.charCodeAt(0));
    return new TextDecoder().decode(new Uint8Array(decodedBytes));
}

export function scrollBottom(el: HTMLElement) {
    el.scrollTop = el.scrollHeight + 100;
}

export function formatDateToYMD(date: any): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, "0"); // mes empieza en 0
    const day = d.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
}
